import React from "react";
import PropTypes from "prop-types";
import MessageContainer from "../MessageContainer";
import { ReactComponent as DocumentSvg } from "../../../../assets/chat/nda-document.svg";

const _prefix = "chat-tendering__nda-sent";

const NDASigned = () => {
  return (
    <MessageContainer alignment={"center"}>
      <div className={_prefix}>
        <div className={`${_prefix}__desc`}>
          <DocumentSvg width={24} />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span className={`${_prefix}__desc__name`}>
              The NDA policy has been signed.
            </span>
          </div>
        </div>
      </div>
    </MessageContainer>
  );
};

NDASigned.propTypes = {};

export default NDASigned;
